import React, { useCallback } from 'react';
import './AgentPanel.css';
import { useConnected } from '../../hooks';
import ConnectCCP from '../ConnectCCP';
import CustomLayout from '../CustomLayout';
import { genLogger } from '../../utils';
import { searchAndOpenRecords } from '../../services';
import { INCIDENT } from '../../constants';

const { log, error } = genLogger('AgentPanel');

export default function () {
  const onConnected = useCallback(async (contact: any) => {
    try {
      const attributes = contact.getAttributes();
      const caseid = attributes.caseid?.value;
      if (caseid) {
        await searchAndOpenRecords(INCIDENT, caseid);
      }
    } catch (err) {
      error('Open case id on call connection', err);
      log(err);
    }
  }, []);
  useConnected(onConnected);

  return (
    <div className="ccp-container">
      <ConnectCCP />
      <CustomLayout />
    </div>
  );
}
